import { Container } from '@mui/material';
import { IApiCallStatus, ValueLabel, variables } from '../common';
import { render, IRequestStatus } from '.';

export function RequestStatus2d({
  properties,
  requests,
  getRequstsCallStatus,
  sortBy,
  sortDirection,
  toggleSort,
  selectedRequestIds,
  disableOperationsHelpDsk,
  toggleRequestSelection,
  confirmCancelRequests,
}: {
  properties: ValueLabel<keyof IRequestStatus>[];
  requests: IRequestStatus[];
  getRequstsCallStatus: IApiCallStatus;
  sortBy: string;
  sortDirection: 'asc' | 'desc';
  toggleSort: (name: string) => void;
  selectedRequestIds: number[];
  disableOperationsHelpDsk: boolean;
  toggleRequestSelection?: (payload: IRequestStatus) => void;
  confirmCancelRequests?: () => void;
}) {
  const s = useStyles;

  switch (getRequstsCallStatus) {
    case null:
      return <Container maxWidth="lg">Loading...</Container>;

    case false:
      return <Container maxWidth="lg">Error</Container>;

    case true:
      return render(s)(properties)({
        sortBy,
        sortDirection,
        toggleSort,
        disableOperationsHelpDsk,
        selectedRequestIds,
        toggleRequestSelection,
        confirmCancelRequests,
      })(requests);

    case void 0:
      return null;

    default:
      return <Container maxWidth="lg">Idk</Container>;
  }
}

const useStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',

    '&>*+*': {
      marginTop: '1rem',
    },

    '@media (min-width: 60em)': {
      display: 'grid',
      gridTemplateColumns: 'repeat(10, auto) ',
      gridAutoRows: 'minmax(auto, 5em)',

      gap: '1px',

      backgroundColor: variables.grayLighter,
      border: variables.cardBorder,
      borderRadius: variables.cardBorderRadius,

      '&>*': {
        backgroundColor: '#fff',
        padding: '1rem',
      },

      '&>*+*': {
        marginTop: '0rem',
      },
    },
  },
  address: {
    fontSize: '1rem',
  },
  properyValue: {
    overflow: 'auto',
  },
};
